var exports = {
  "k": "xfb577c5e--5ce952--container",
  "K": "xfb577c5e--5ce952--icon",
};

module.exports = exports;
